
  import {Component, Vue} from 'vue-property-decorator';
  import Header from "@/components/Header.vue";
  import LandingSection from "@/components/LandingSection.vue";
  import PlatformChoice from "@/components/PlatformChoice.vue";
  import DownloadWin30 from "@/components/DownloadWin30.vue";
  import DownloadMac30 from "@/components/DownloadMac30.vue";
  import DownloadLin30 from "@/components/DownloadLin30.vue";
  import DownloadZip30 from "@/components/DownloadZip30.vue";
  import License from "@/components/License.vue";
  import {gaSendPageview} from "@/components/Analytics";
  import Cookies from "js-cookie";

  @Component({
    components: {DownloadZip30, DownloadLin30, DownloadMac30, DownloadWin30, LandingSection, Header, PlatformChoice, License}
  })
  export default class Download30 extends Vue {
    private versionShort = "3.2";
    private version = "3.2.3240";
    private releaseDate = "31 Mar, 2022";
    private isPaidDownload = false;
    private winSize = "111 Mb";
    private winMd5 = " 9552897f5d01fd685e84004202900308";
    private winVirusTotal = "9fa2311ccf68421c9f5bcf86b6dd233968c89d3e3e242ee8910b7810e7f1f26e";
    private macSize = "115 Mb";
    private linSize = "50 Mb";
    private zipSize = "39 Mb";

    constructor() {
      super();
      this.isPaidDownload = window.location.pathname.endsWith("paid");
    }
    private cdnUrl(path: string): string {
      return path;
    }

    public mounted() {
      gaSendPageview();
    }
  }
